import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import './inertia';
import './application';
import './cookie-consent-alter';
import { registerCookieConsentTracking } from './cookie-consent-tracking';

registerCookieConsentTracking();
